<template>
  <div class="mainBox">
    <!-- head BGC -->
    <div class="bgcBox">
      <img class="bgcImg" src="../assets/images/pageBgc.png" alt="" />
      <img class="leftIcon" src="../assets/images/leftIcon.png" alt="" />
      <img class="rightIcon" src="../assets/images/rightIcon.png" alt="" />
    </div>
    <!-- header -->
    <Header
      @openlogin="openlogin"
      ref="headRef"
      :homePage="true"
      style="margin: 0 0 0.3rem 0.1rem"
    />
    <!-- loan Detail Box -->
    <div class="loanDetail">
      <!-- title -->
      <h5>El monto solicitado de su préstamo</h5>
      <!-- loan Amount -->
      <h2>
        <div style="display: flex; align-items: center;">
          S/{{
            currentNum
              ? add_comma_toThousands(currentNum)
              : add_comma_toThousands(loanNum)
          }}
          <img
            v-show="currentNum"
            style="width: 0.3rem;height: 0.3rem;margin: 0.1rem 0 0 0.05rem;"
            src="../assets/images/upIcon.png"
            alt=""
          />
        </div>
        <p
          v-show="currentNum"
          style="
             font-family: Roboto, Roboto;
             font-weight: 400;
             font-size: 0.24rem;
             color: #999999;
             line-height: 0.28rem;
             text-align: center;
             text-decoration-line: line-through;
          "
        >
          S/ {{ add_comma_toThousands(loanData.unuseCouponBorrowAmount) }}
        </p>
      </h2>
      <!-- loan range -->
      <van-slider
        v-model="loanNum"
        :step="10"
        :min="minAmount"
        :max="maxAmount"
        @change="onChange"
      />
      <div class="numBox">
        <p>s/ {{ userInfo.is_reloan == 1 ? minAmount : "100" }}</p>
        <p>s/ {{ userInfo.is_reloan == 1 ? maxAmount : "5,000" }}</p>
      </div>
      <!-- loan Days Choose -->
      <div
        class="laonDaysChoose"
        :style="{ marginBottom: userInfo.is_reloan == 1 ? '0' : '0.6rem' }"
        @click="openDayChoose"
      >
        <p>Días de plazo préstamo</p>
        <p>
          <span>{{ currentDays ? currentDays : loanDay }} Días</span>
          <van-icon name="arrow-down" />
        </p>
      </div>
      <p
        style="
            text-align: right;
            text-decoration-line: line-through;
            font-family: Roboto, Roboto;
            font-weight: 400;
            font-size: 0.24rem;
            color: #999999;
            padding-right: 0.5rem;
          "
        v-show="currentDays"
      >
        {{ loanData.unuseCouponPeriod }} Días
      </p>
      <!-- coupon list -->
      <div
        class="couponBox"
        v-show="userInfo.is_reloan == 1"
        @click="openCoupon"
      >
        <!-- 左侧文案 -->
        <div class="leftText">
          <img src="../assets//images/couponIcon.png" alt="" />
          <p>Cupón</p>
        </div>
        <!-- 右侧文案 -->
        <div class="rightText">
          <p v-show="!couponIds.length">Elegir</p>
          <ul v-show="couponIds.length" style="display: flex;">
            <li v-for="item in chooseCouponList">
              <span>
                {{ item.coupon_type == 6 ? "-" : "+" }}
                {{ item.coupon_type == 4 ? "S/" : "" }}
              </span>
              {{ item.distribute_amount }}
              <span style="font-size: 0.26rem;margin-left: 0.03rem;">
                {{ couponAmountText[item.coupon_type] }}
              </span>
            </li>
          </ul>
          <van-icon name="arrow"></van-icon>
        </div>
      </div>
      <!-- loan Btn -->
      <div class="loanButton" @click="submitLoan">
        Solicitar ahora su préstamo
      </div>
      <!-- protocol -->
      <!-- <p class="protocolBox" v-if="userInfo.is_reloan == 1">
        Acepto las condiciones del
        <a @click="jumpLoanProtocol">contrato de préstamo</a>
      </p> -->
    </div>
    <!-- trial Detail Box -->
    <div class="trialDetail" v-show="userInfo.is_reloan == 1">
      <h3>Detalles del préstamo</h3>
      <ul>
        <li>
          <p>Fecha de vencimiento</p>
          <p>{{ reLoanDate || moment(repaymentData, 1, 1) }}</p>
        </li>
        <li>
          <p>Monto de depósito</p>
          <p>S/ {{ add_comma_toThousands(loanNum) }}</p>
        </li>
        <li>
          <p>Monto de pago</p>
          <p>S/ {{ add_comma_toThousands(Math.ceil(totalRepayment)) }}</p>
        </li>
        <li @click="openDetil">
          <p>
            Tasa de interés total
          </p>
          <van-icon
            :style="{
              transform: detailShow ? 'rotate(180deg)' : 'rotate(0)',
              transition: 'all .2s',
            }"
            name="arrow-down"
          />
          <!-- <p>S/ {{ totalInterestRate }}</p> -->
        </li>
        <li
          :style="{
            height: detailShow
              ? loanData.coupon_reduction_amount
                ? '3rem'
                : '2.2rem'
              : '0',
            overflow: 'hidden',
            transition: 'all .2s',
            marginBottom: 0,
            background: '#F5F5F5',
            borderRadius: '0.1rem',
            display: 'block',
          }"
        >
          <ul class="childList">
            <li>
              <p>Interés</p>
              <p>S/ {{ add_comma_toThousands(Math.ceil(totalInterest)) }}</p>
            </li>
            <li>
              <p>Cargo de servicios</p>
              <p>S/ {{ add_comma_toThousands(Math.ceil(totalServiceFee)) }}</p>
            </li>
            <li>
              <p>IGV</p>
              <p>S/ {{ add_comma_toThousands(Math.ceil(igv)) }}</p>
            </li>
            <li v-if="loanData.coupon_reduction_amount">
              <p>Importe de la reducción</p>
              <p>
                S/ {{ add_comma_toThousands(loanData.coupon_reduction_amount) }}
              </p>
            </li>
          </ul>
        </li>
      </ul>
    </div>

    <!-- Ventajas del préstam -->
    <!-- <div class="infoBox" id="first">
      <h3>Ventajas del préstamo MasterSol</h3>
      <ul>
        <li v-for="(item, index) in oneList" :key="index">
          <img src="../assets/images/infoIcon.png" alt="" />
          <p>{{ item }}</p>
        </li>
      </ul>
    </div> -->
    <!-- REQUISITOS -->
    <!-- <div class="infoBox" id="second">
      <h3>REQUISITOS</h3>
      <ul>
        <li v-for="(item, index) in twoList" :key="index">
          <img src="../assets/images/infoIcon.png" alt="" />
          <p>{{ item }}</p>
        </li>
      </ul>
    </div>

    <div class="progress" id="third">
      <h5>Pasos para solicitar</h5>
      <img src="../assets/images/progressImg.png" alt="" />
    </div> -->

    <ContactOrAbout style="margin-top: 0.2rem" />

    <!-- choose Day Visible -->
    <van-popup v-model="loanDayShow" round position="bottom">
      <van-picker
        title=""
        show-toolbar
        :columns="columns"
        value-key="max_period"
        confirm-button-text="confirmación"
        cancel-button-text="cancelación"
        :default-index="columns.length - 1"
        @cancel="loanDayShow = false"
        @confirm="onConfirm"
      />
    </van-popup>

    <!-- login Visible -->
    <van-popup
      v-model="loaginVisible"
      class="loginVanpopup"
      position="bottom"
      closeable
      :style="{ minHeight: '30%' }"
      round
    >
      <h3>Por favor, ingrese y registre su número de teléfono</h3>
      <!-- 允许输入正整数，调起纯数字键盘 -->
      <van-field
        placeholder="Número de 9 dígitos"
        v-model="loginInfo.loginUser"
        type="digit"
        label="+51"
        maxLength="9"
      />
      <van-field
        v-model="loginInfo.auth_code"
        center
        clearable
        label=""
        placeholder="Introduzca el código"
        type="digit"
        maxLength="4"
      >
        <template #button>
          <van-button
            @click="getCodeBtn(1)"
            :disabled="sendStatus"
            size="small"
            type="primary"
            >{{ sendStatus ? codeCountdown + " S" : "Enviar" }}
          </van-button>
        </template>
      </van-field>
      <p class="titleText">
        También se puede probar otras formas o contactar directamente con el
        servicio de atención al cliente
      </p>
      <div class="otherContact">
        <div @click="getCodeBtn(3)">
          <img src="../assets/images/playPhone.png" alt="" />
          <p>Obtención por teléfono</p>
        </div>
        <div @click="getCodeBtn(4)">
          <img src="../assets/images/whatsappIcon.png" alt="" />
          <p>Obtención vía WhatsApp</p>
        </div>
      </div>
      <div class="loginBtn" @click="loginBtn">Login</div>
    </van-popup>
  </div>
</template>

<script>
import Header from "../components/header.vue";
import {
  getCode,
  login,
  // getInfor,
  orderConfirm,
  getProduct,
  createOrderForm,
  orderCalculate,
  getUserInforList,
  getCurrentInfo,
} from "../utils/api/h5page.js";
import ContactOrAbout from "../components/contactOrAbout.vue";
import { Dialog } from "vant";
export default {
  data() {
    return {
      currentNum: 0,
      moment: this.$setMoment,
      loanDayShow: false,
      detailShow: false,
      loaginVisible: false,
      sendStatus: false,
      oneList: [
        "Obtienes el préstamo en 3 simples pasos",
        "Aumenta siempre tu de monto y tu crédito",
        "Soporta métodos de pago como BCP, BBVA, Scotiabank, INTEREBANK y TAMBO etc",
        "MasterSol mantenemos tu información segura mediante el cifrado SSL",
      ],
      twoList: [
        "Ser residente de Perú",
        "Tener más de 18 años",
        "Tener un número de celular",
      ],
      couponAmountText: {
        4: "", // 提额
        5: "días", // 延期券
        6: "%", // 折扣券
      },
      loanNum: 4000, // 借款金额
      loanDay: 180, // 借款天数
      totalServiceFee: "", // 总服务费
      totalRepayment: "", // 总应还
      totalInterest: "", // 总利息
      totalInterestRate: "", // 总利率
      igv: "",
      minAmount: 100,
      maxAmount: 5000,
      // token_key: "",
      timeInterval: null,
      columns: [
        { max_period: 7 },
        { max_period: 14 },
        { max_period: 30 },
        { max_period: 45 },
        { max_period: 90 },
        { max_period: 180 },
      ],
      codeCountdown: 30,
      product_id: "",
      loginInfo: {
        loginUser: "",
        auth_code: "",
      },
      reLoanDate: "",
      userFormInfo: {},
      repaymentData: "",
      loanData: {},
      couponIds: [],
      chooseCouponList: [],
      currentDays: 0,
    };
  },
  props: {
    userInfo: {
      type: Object,
    },
  },
  components: {
    Header,
    ContactOrAbout,
  },
  methods: {
    // change loan Amount
    onChange() {
      if (this.userInfo.is_reloan == 1) {
        this.calculateNum();
      } else {
        this.calculate();
      }
    },

    calculate() {
      let nowTime = new Date();
      nowTime.setDate(nowTime.getDate() + this.loanDay);
      this.repaymentData = nowTime.getTime();
      // 总服务费
      this.totalServiceFee = (this.loanNum * 100 * this.loanDay) / 10000;
      // 总利息
      this.totalInterest = (this.loanNum * 279 * this.loanDay) / 10000;
      // IGV
      this.igv = (Math.ceil(this.totalServiceFee) * 1800) / 1000;
      setTimeout(() => {
        // 总利率
        let totalInterestRate =
          Math.ceil(this.totalInterest) +
          Math.ceil(this.totalServiceFee) +
          Math.ceil(this.igv);
        // 总应还
        this.totalRepayment = totalInterestRate + this.loanNum;
      }, 0);
    },
    // choose LoanDays
    openDayChoose() {
      this.loanDayShow = true;
    },
    // submit
    async submitLoan() {
      if (!localStorage.getItem("token")) {
        return (this.loaginVisible = true);
      }
      // this.token_key = localStorage.getItem("tokenKey");
      // this.getCurrentNum();
      const res = await getCurrentInfo();
      this.currentStep = res.data.data.current_step;

      sessionStorage.setItem(
        "jsonData",
        JSON.stringify({
          loanNum: this.loanNum,
          loanDay: this.loanDay,
        })
      );

      if (res.data.data.current_step == 1006) {
        this.$Toast(
          "Su selfie ha caducado, por favor complete selfie antes de prestar un nuevo préstamo"
        );
        this.$router.push({
          path: "/faceIdentify",
          query: {
            couponIds: this.couponIds.length ? this.couponIds : "",
          },
        });
        return;
      }

      if (
        res.data.data.current_step !== 1006 &&
        res.data.data.current_step !== 1110 &&
        res.data.data.current_step !== 105
      ) {
        this.$router.push("/registerInfo");
        return;
      }

      // 首贷用户
      if (this.userInfo.is_reloan == 0) {
        const params = {
          loan: this.loanNum.toString(),
          period: this.loanDay.toString(),
          is_new: 1,
          coupon_id: "",
          order_label: "FAST_RELOAN",
          token_key: localStorage.getItem("tokenKey"),
        };

        if (res.data.data.current_step == 1110) {
          this.$emit("openLoading");
          orderConfirm(params).then(({ data }) => {
            if (data.code == 0) {
              this.$emit("getUserInformation");
            } else {
              this.$emit("closeLoading");
            }
          });
        }
      }
      // 复贷用户
      else if (
        this.userInfo.is_reloan == 1 &&
        res.data.data.current_step == 105
      ) {
        const params = {
          loan: this.loanNum,
          period: this.loanDay,
          is_new: 2,
          couponIds: this.couponIds.length ? this.couponIds : "",
          order_label: "FAST_RELOAN",
          token_key: localStorage.getItem("tokenKey"),
        };
        if (!localStorage.getItem("tokenKey")) {
          this.loading = false;
          return Dialog.alert({
            message:
              "Este navegador no es compatible con los servicios relacionados con MasterSol, por lo que no podemos recibir su solicitud. Por favor, cambie de navegador y continúe enviando.",
            theme: "round-button",
            confirmButtonText: "copy",
          }).then(() => {
            // on close
            if (window.location.host == "www.mastersol.tech") {
              navigator.clipboard.writeText("https://www.mastersol.tech/home");
            } else {
              navigator.clipboard.writeText(
                "https://mastersol.jinglewill.com/211345390/#/home"
              );
            }
          });
        }
        this.$emit("openLoading");
        orderConfirm(params).then(({ data }) => {
          if (data.code == 0) {
            this.$emit("getUserInformation");
          }
        });
      }
    },
    openlogin() {
      this.loaginVisible = true;
    },
    getUserFormInfo() {
      getUserInforList().then(({ data }) => {
        // console.log(data);
        this.userFormInfo = data.data;
      });
    },

    async getCurrentNum() {
      const res = await getCurrentInfo();
      this.currentStep = res.data.data.current_step;
      // getCurrentInfo().then(({ data }) => {
      // });
    },

    // detail amount show
    add_comma_toThousands(num) {
      var nums = (num || 0).toString();
      var result = "";
      while (nums.length > 3) {
        result = "," + nums.slice(-3) + result;
        nums = nums.slice(0, nums.length - 3);
      }
      if (nums) {
        result = nums + result;
      }
      return result;
    },
    // catch loan detail
    openDetil() {
      this.detailShow = !this.detailShow;
    },
    // send code
    getCodeBtn(userType) {
      if (!this.loginInfo.loginUser || this.loginInfo.loginUser.length < 9)
        return this.$Toast("Número de 9 dígitos");
      if (this.sendStatus) {
        return this.$Toast("El código de verificación ha sido enviado");
      }
      this.sendStatus = true;
      this.timeInterval = setInterval(() => {
        if (this.codeCountdown == 1) {
          clearInterval(this.timeInterval);
          this.codeCountdown = 30;
          this.sendStatus = false;
          return;
        }
        this.codeCountdown--;
      }, 1000);
      const params = {
        loginUser: "+51" + this.loginInfo.loginUser,
        userType,
        verifyCodeType: 8,
      };
      // 接口
      getCode(params).then(({ data }) => {
        if (data.code !== 0) {
          clearInterval(this.timeInterval);
          this.codeCountdown = 30;
          this.sendStatus = false;
        }
      });
    },

    // 登录按钮
    loginBtn() {
      if (!this.loginInfo.loginUser || this.loginInfo.loginUser.length < 9)
        return this.$Toast(
          "Por favor, introduzca un número de teléfono móvil de 9 dígitos."
        );
      if (!this.loginInfo.auth_code)
        return this.$Toast("Por favor, introduzca el Código de verificación");
      if (this.loginInfo.auth_code.length !== 4) {
        return this.$Toast("Introduzca el Código de verificación de 4 dígitos");
      }
      const params = {
        ...this.loginInfo,
        userType: 1,
        firebase_id: "",
        notice_switch: 0,
        loginUser: "+51" + this.loginInfo.loginUser,
      };

      this.$emit("openLoading");
      // 登录
      login(params).then(({ data }) => {
        if (data.code == 0) {
          localStorage.setItem("token", data.data.access_token);
          this.loaginVisible = false;
          this.$store.commit("setToken", data.data.access_token);
          this.$Toast("Login successful");
          this.getCurrentNum();
          this.getUserFormInfo();
          // get user information
          this.getUserInformation();
        } else {
          this.$emit("closeLoading");
          // clearInterval(this.timeInterval);
          // this.codeCountdown = 60;
          // this.sendStatus = false;
        }
      });
    },

    onConfirm(val) {
      console.log("[ val ] >", val);
      if (val.id) {
        this.setProductDetail(val);
      }
      this.loanDay = val.max_period;
      this.loanDayShow = false;
      this.calculate();
    },

    // 获取用户订单信息
    getUserInformation() {
      this.$emit("getUserInformation");
      this.$refs.headRef.setToken();
      setTimeout(() => {
        this.reloanDeal();
      }, 100);
    },

    // 处理复贷逻辑
    async reloanDeal() {
      // 获取产品列表
      getProduct().then(({ data }) => {
        if (data.code == 0) {
          // 复贷时 调取试算接口
          if (this.userInfo.is_reloan == 1) {
            this.setProductDetail(data.data.product_suitable[0]);
            this.columns = data.data.product_suitable;
          }
        }
      });
    },
    // 配置产品详情
    setProductDetail(row) {
      this.loanNum = row.max_amount;
      this.loanDay = row.max_period;
      this.minAmount = row.min_amount;
      this.maxAmount = row.max_amount;
      this.product_id = row.id;
      setTimeout(() => {
        this.calculateNum();
      }, 10);
    },

    // 复贷滑动金额更新临时订单 更新试算
    calculateNum() {
      const params = {
        loan: this.loanNum.toString(),
        period: this.loanDay.toString(),
        product_id: this.product_id.toString(),
        order_label: "FAST_RELOAN",
      };
      createOrderForm(params).then((res) => {
        if (res.data.code == 0) {
          this.getCalculateData();
        }
      });
    },

    // 调用试算接口
    getCalculateData() {
      // 试算接口
      orderCalculate({
        // accountCouponId: "-1",
        borrowAmount: this.loanNum,
        couponIds: this.couponIds || "",
      }).then(({ data }) => {
        this.loanData = data.data;
        this.totalServiceFee = data.data.totalServiceFee;
        this.totalRepayment = data.data.totalRepayAmount;
        this.totalInterest = data.data.totalInterest;
        this.igv = data.data.totalGst;
        this.reLoanDate = data.data.firstRepayDateFormat;
        this.loanNum = data.data.unuseCouponBorrowAmount;
        this.$emit("closeCoupon");
        if (data.data.borrowAmount > data.data.unuseCouponBorrowAmount) {
          this.currentNum = data.data.borrowAmount;
        } else {
          this.currentNum = 0;
        }

        if (data.data.period > data.data.unuseCouponPeriod) {
          this.currentDays = data.data.period;
        } else {
          this.currentDays = 0;
        }
      });
    },

    jumpLoanProtocol() {
      let urlparams = encodeURIComponent(JSON.stringify(this.loanData));
      if (window.location.host == "www.mastersol.tech") {
        window.open(
          "https://www.mastersol.tech/h5/loan.html?userInfo=" + urlparams
        );
      } else {
        window.open(
          "https://mastersol.jinglewill.com/211345390/h5/loan.html?userInfo=" +
            urlparams
        );
      }
    },

    openCoupon() {
      this.$emit("openCoupon", 2, this.chooseCouponList);
    },

    // 使用优惠券后
    chooseCoupon(couponIds, couponArr) {
      this.couponIds = couponIds;
      this.chooseCouponList = couponArr;
      // this.currentDays = 0;
      // couponArr.map((item) => {
      //   if (item.coupon_type == 5) {
      //     this.currentDays = item.distribute_amount;
      //   }
      // });
      this.$emit("openLoading");
      this.reloanDeal(couponIds);
    },
  },
  mounted() {
    this.calculate();
    setTimeout(() => {
      client.record("login").then((r) => {
        console.log("[ home-r ] >", r);
        localStorage.setItem("tokenKey", r);
      });
    }, 10);
    if (localStorage.getItem("token")) {
      this.getUserInformation();
      this.$store.commit("setToken", localStorage.getItem("token"));
      this.getUserFormInfo();
      this.getCurrentNum();
    }
  },
  created() {},
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.mainBox {
  box-sizing: border-box;
  background-color: #f5f5f5;
  height: 100%;
  overflow: hidden;
  padding: 0 0.2rem 0.72rem;
}
.bgcBox {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  .bgcImg {
    width: 100%;
  }
  .leftIcon {
    width: 0.63rem;
    position: absolute;
    left: 0;
    top: 1.29rem;
    z-index: 2;
  }
  .rightIcon {
    width: 0.6rem;
    position: absolute;
    bottom: 0;
    right: 0;
    transform: translateY(50%);
    z-index: 2;
  }
}

.loanDetail {
  position: relative;
  z-index: 1;
  width: 100%;
  min-height: 5.9rem;
  background: #ffffff;
  border-radius: 0.2rem;
  margin: 0 auto;
  padding: 0.47rem 0.3rem 0.39rem;
  h5 {
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.27rem;
    color: #333333;
  }
  h2 {
    width: max-content;
    font-family: Roboto, Roboto;
    font-weight: 700;
    font-size: 0.6rem;
    color: #333333;
    margin: 0.17rem 0 0.3rem;
  }
  .van-slider {
    height: 0.14rem;
    background: #f2f2f2;
    border-radius: 0;
    width: 96%;
    margin: 0 auto;
  }
  /deep/ .van-slider__bar {
    background: #c90000;
    border-radius: 0;
  }
  /deep/ .van-slider__button {
    box-sizing: border-box;
    width: 0.4rem;
    height: 0.4rem;
    background: #ffffff;
    border: 0.08rem solid #c90000;
  }

  .numBox {
    display: flex;
    justify-content: space-between;
    margin: 0.29rem 0 0.4rem;
    p {
      font-family: Roboto, Roboto;
      font-weight: 400;
      font-size: 0.25rem;
      color: #666666;
    }
  }

  .laonDaysChoose {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // margin-bottom: 0.6rem;
    p {
      font-family: Roboto, Roboto;
      font-size: 0.29rem;
      color: #333333;
      i {
        color: #cdcdcd;
        margin-left: 0.15rem;
        font-size: 0.35rem;
      }
    }
  }
  .couponBox {
    width: 100%;
    height: 0.8rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0.2rem 0;
    border-top: 0.02rem dashed #e9e9e9;
    .leftText {
      display: flex;
      align-items: center;
      font-family: Roboto, Roboto;
      font-weight: 400;
      font-size: 0.26rem;
      color: #333333;
      img {
        width: 0.4rem;
        height: 0.4rem;
        margin-right: 0.15rem;
      }
    }
    .rightText {
      display: flex;
      align-items: center;
      p {
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 0.26rem;
        color: #666666;
        margin-right: 0.1rem;
      }
      .van-icon {
        color: #666666;
        font-size: 0.3rem;
      }

      ul {
        display: flex;
        li {
          padding: 0.05rem 0.1rem;
          background: #1e1e1e;
          border-radius: 0.1rem;
          font-family: Roboto, Roboto;
          font-weight: 400;
          font-size: 0.25rem;
          color: #ffffff;
          margin-right: 0.1rem;
        }
      }
    }
  }

  .loanButton {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 5.8rem;
    height: 0.8rem;
    background: #c90000;
    box-shadow: inset 0rem 0.16rem 0.32rem 0rem rgba(255, 255, 255, 0.22);
    border-radius: 0.4rem;
    margin: 0 auto;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 0.32rem;
    color: #ffffff;
  }

  .protocolBox {
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.22rem;
    color: #999999;
    text-align: center;
    margin-top: 0.45rem;
    a {
      color: #333333;
      text-decoration: underline;
    }
  }
}

.trialDetail {
  width: 100%;
  background: #ffffff;
  border-radius: 0.2rem;
  padding: 0.34rem 0.24rem;
  margin: 0.3rem 0 0.17rem;
  h3 {
    font-family: Roboto, Roboto;
    font-weight: 700;
    font-size: 0.32rem;
    color: #333333;
    margin-bottom: 0.4rem;
  }
  ul {
    li {
      display: flex;
      justify-content: space-between;
      margin-bottom: 0.3rem;
      p {
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 0.26rem;
        color: #333333;
      }
      .van-icon-arrow-down {
        font-size: 0.32rem;
      }
      .childList {
        padding: 0.31rem 0.24rem;
        li {
          p {
            font-family: Roboto, Roboto;
            font-weight: 400;
            font-size: 0.24rem;
            color: #666666;
          }
          &:last-child {
            margin: 0;
          }
        }
      }
    }
  }
}

.infoBox {
  width: 100%;
  padding: 0.4rem 1rem 0.4rem 0.3rem;
  background: #ffffff;
  border-radius: 0.2rem;
  margin-bottom: 0.3rem;
  h3 {
    text-align: center;
    font-family: Roboto, Roboto;
    font-weight: 700;
    font-size: 0.32rem;
    color: #333333;
    margin-bottom: 0.4rem;
  }
  ul {
    li {
      display: flex;
      font-family: Roboto, Roboto;
      font-weight: 400;
      color: #333333;
      margin-bottom: 0.3rem;
      p {
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 0.24rem;
        color: #333333;
        margin-left: 0.1rem;
      }
      img {
        width: 0.3rem;
        height: 0.3rem;
        vertical-align: middle;
      }
    }
  }
}

.progress {
  width: 100%;
  background: #ffffff;
  border-radius: 0.2rem;
  padding-top: 0.34rem;
  text-align: center;
  h5 {
    text-align: center;
    font-family: Roboto, Roboto;
    font-weight: 700;
    font-size: 0.32rem;
    color: #333333;
    margin-bottom: 0.42rem;
  }
  img {
    width: 5.6rem;
  }
}

.loginVanpopup {
  padding: 0.4rem;
  /deep/ .van-popup__close-icon--top-right {
    top: 0.47rem;
    right: 0.37rem;
    font-size: 0.37rem;
  }
  h3 {
    width: 4.2rem;
    font-family: Roboto, Roboto;
    font-weight: 700;
    font-size: 0.27rem;
    color: #333333;
    margin-bottom: 0.38rem;
  }
  .van-cell {
    border-bottom: 0.02rem solid #e4e4e4;
    padding: 0.24rem 0.16rem;
    align-items: center;
  }
  /deep/ .van-field__control {
    font-size: 0.27rem;
  }
  /deep/ .van-field__label {
    width: 0.6rem;
    font-size: 0.27rem;
  }
  .van-button {
    width: 1.5rem;
    height: 0.5rem;
    background: #c90000;
    border-radius: 0.26rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.24rem;
    color: #ffffff;
    border: none;
    line-height: inherit;
  }

  .loginBtn {
    width: 5.8rem;
    height: 0.8rem;
    background: #c90000;
    box-shadow: inset 0rem 0.16rem 0.32rem 0rem rgba(255, 255, 255, 0.22);
    border-radius: 0.4rem;
    margin: 0.62rem auto 0;
    font-family: PingFangSC, PingFang SC;
    font-weight: 700;
    font-size: 0.32rem;
    color: #ffffff;
    text-align: center;
    line-height: 0.8rem;
  }
  .titleText {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 0.24rem;
    color: #333333;
    text-align: center;
    margin: 0.52rem 0 0.32rem;
  }
  .otherContact {
    display: flex;
    justify-content: space-between;
    padding: 0 0.45rem;
    div {
      display: flex;
      flex-direction: column;
      align-items: center;
      p {
        width: 1.36rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 0.2rem;
        color: #666666;
        text-align: center;
      }
      img {
        width: 0.5rem;
        height: 0.5rem;
        margin-bottom: 0.18rem;
      }
    }
  }
}
</style>
